module.exports = __webpack_public_path__ + "img/lf4.ca6a7c7a.png";